<app-page-header subtitle="Gecombineerde weekrapporten"> </app-page-header>

<div class="container">
    <div>
        <p>Kies een project om hiervoor alle weekrapporten in een gecombineerde pdf te ontvangen via e-mail.</p>
    </div>
    <ng-select
        [formControl]="fcProjectId"
        [items]="projects"
        [clearable]="false"
        [typeahead]="projectSearch$"
        placeholder="Projectnummer"
        bindLabel="afas_project_id"
        bindValue="afas_project_id">
        <ng-template ng-label-tmp let-item="item">
            <b>{{ item.afas_project_id }}</b> {{ item.name }}
        </ng-template>
        <ng-template ng-label-tmp let-item="item">
            <b>{{ item.afas_project_id }}</b> {{ item.name }}
        </ng-template>
        <ng-template *ngIf="!searching" ng-option-tmp let-item="item" let-index="index">
            <b class="">{{ item.afas_project_id }}</b> {{ item.name }}
        </ng-template>
        <ng-template *ngIf="searching" ng-option-tmp let-item="item" let-index="index">
            <div class="option-searching-item" [class.pl-3]="item.parent_id">
                <div>
                    <b>{{ item.afas_project_id }}</b> {{ item.name }}
                </div>
                @if (item.realisation_times) {
                    <div>
                        week
                        @for (time of item.realisation_times; track time; let last = $last; let index = $index) {
                            <small>
                                {{ time.week }}
                                @if (time.year != item.realisation_times[index + 1]?.year) {
                                    ({{ time.year }})
                                }
                                {{ last ? '' : ', ' }}
                            </small>
                        }
                    </div>
                }
            </div>
        </ng-template>
    </ng-select>

    @if (reports) {
        <div>
            <table>
                <tr>
                    <th>Project</th>
                    <th>Beschikbare weekrapporten</th>
                </tr>
                @for (report of reports; track report) {
                    <tr>
                        <th class="pr-2">
                            {{ report.afas_project_id }}
                        </th>
                        <td>
                            @for (week of report.projectComments; track week; let last = $last) {
                                <a
                                    routerLink="/project-rapport/{{ week.afas_project_id }}/{{ week.week }}/{{
                                        week.year
                                    }}"
                                    >{{ week.week }} -{{ week.year }}</a
                                >{{ last ? '' : ', ' }}
                            }
                        </td>
                    </tr>
                }
            </table>
            <div>
                <button [disabled]="pdfRequested" (click)="makeReport()" mat-raised-button color="primary">
                    {{ pdfRequested ? 'Gecombineerd weekrapport opgevraagd' : 'Maak gecombineerd weekrapport' }}
                </button>
            </div>
        </div>
    }

    @if ((Functionalities.AfasInvoices | hasFunctionality) && projectId()) {
        <div class="mt-4">
            <th>Inkoopfacturen uit Afas</th>
            <app-project-invoices [projectID]="projectId()"></app-project-invoices>
        </div>
    }
</div>
